module.exports = __webpack_public_path__ + "static/img/89-1.20321b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/89-1.jpg
// module id = zZvA
// module chunks = 0